Controller = App.loadClass 'core::Angular/Controller'

class exports.ManagementIntensityController extends Controller
    constructor: (
        @scope,
        @transitions,
        @modal,
        @http,
        @service,
        @state
    ) ->
        super

    multipleRxMapsDeliveredForField: (fieldSurvey) =>
        fieldSurvey.data.management_intensity is 'Intense' and @service.rxMaps[fieldSurvey.fields_id]?.length > 1
